import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Box, IconButton } from 'seagull';
import { CloseCross } from 'seagull/icons/essentials';
import { getTestIds } from 'seagull/utils/TestIds';
import { OrGroup } from '~/components/AiSearchChips/OrGroup/OrGroup';
import sharedStyles from '~/components/AiSearchChips/OrGroup/OrGroup.module.scss';
import { OrValueGroupChip } from '~/components/AiSearchChips/OrValueGroupChip/OrValueGroupChip';
import { collapsedValueGroupValues } from '~/components/AiSearchChips/OrValueGroupChip/orValueGroupCollapse';
import { buildAgreementPredicateChipUnits, buildPredicateCallbacks } from '../AgreementPredicateChips.utils';
import { useAgreementsChipConnector } from '../agreementsChipConnector';
import { useAgreementsBundlesGrammar } from '../agreementsCollectionGrammar';
import { useAgreementSettingsGrammar } from '../agreementSettingsGrammar';
import { armChipTestIds, nestedGroupActions } from './AgreementOrGroup.utils';
import { agreementCollapsedGroupArm, agreementOrValueGroupFields, collapsibleAgreementGroup } from './agreementOrValueGroup';
export const GetAgreementOrGroupTID = (parentTestId)=>getTestIds(parentTestId);
export const AgreementOrGroup = (param)=>{
    let { testId, arms, tone, texts, serviceGrammar, onArmChange, onClearGroup, onToggleConnector } = param;
    const { AgreementOrGroupTestIds } = useMemo(()=>GetAgreementOrGroupTID(testId), [
        testId
    ]);
    const connector = useAgreementsChipConnector();
    const settingsGrammar = useAgreementSettingsGrammar();
    const collectionGrammar = useAgreementsBundlesGrammar();
    const renderArm = (arm, index)=>buildAgreementPredicateChipUnits({
            predicate: arm,
            testIds: armChipTestIds(AgreementOrGroupTestIds.Arm, index),
            callbacks: buildPredicateCallbacks(arm, (next)=>onArmChange(index, next)),
            groupActions: nestedGroupActions(arm, index, onArmChange),
            texts,
            serviceGrammar,
            settingsGrammar,
            collectionGrammar
        });
    const collapsed = collapsibleAgreementGroup(arms);
    if (collapsed != null) {
        return /*#__PURE__*/ _jsx(Box, {
            testId: AgreementOrGroupTestIds.Root(),
            inline: true,
            className: sharedStyles.group,
            children: /*#__PURE__*/ _jsx(OrValueGroupChip, {
                testId: AgreementOrGroupTestIds.ValueGroup(),
                field: collapsed.field,
                fields: agreementOrValueGroupFields(texts),
                values: collapsedValueGroupValues(collapsed),
                connectorTone: tone,
                texts: {
                    apply: texts.applyText,
                    connector: connector.labels
                },
                bi: {
                    edit: {
                        name: 'agreements_ai_chip_value_group_edit'
                    },
                    apply: {
                        name: 'agreements_ai_chip_value_group_apply'
                    },
                    remove: {
                        name: 'agreements_ai_chip_value_group_remove'
                    }
                },
                onValueChange: (index, value)=>onArmChange(index, agreementCollapsedGroupArm(collapsed, index, value)),
                onRemove: onClearGroup
            })
        });
    }
    return /*#__PURE__*/ _jsx(OrGroup, {
        testIds: {
            root: AgreementOrGroupTestIds.Root(),
            arm: AgreementOrGroupTestIds.Arm.Root,
            connector: AgreementOrGroupTestIds.Connector
        },
        arms: arms,
        tone: tone,
        connector: connector,
        armGap: 8,
        armWrap: true,
        groupWrap: false,
        onToggle: onToggleConnector,
        renderArm: renderArm,
        trailing: /*#__PURE__*/ _jsx(IconButton, {
            testId: AgreementOrGroupTestIds.Remove(),
            bi: {
                name: 'agreements_ai_chip_remove_or_group'
            },
            onClick: onClearGroup,
            size: "small",
            children: /*#__PURE__*/ _jsx(CloseCross, {
                size: 10
            })
        })
    });
};
